import {useState, useEffect} from 'react'
import FileView from "./FileView"
import ThemeSelector from "./ThemeSelector";
import { Resizable } from 'react-resizable';

import 'react-resizable/css/styles.css';
export default function RightSideBar({
    rightSidebarContent,
    setRightSidebarContent,
    rightSidebarHeight,
    initial,
    setInitial,
    showResize,
    rightSidebarWidth,
    setRightSidebarWidth,
    colorTheme,
    setColorTheme,
    inSpace,
    setInSpace,
    mouseDown,
    setMouseDown,
    theme,
}) {
    const [rightSideBar, setRightSideBar] = useState(false)
    const [display, setDisplay] = useState('none');
    useEffect(()=>{
        if(mouseDown && inSpace) {
            setDisplay('block');

        }else {
            setDisplay('none')
        }

    }, [mouseDown])
    const right = -1 * rightSidebarWidth;



    function handleResizeStart(e) {
        setInitial(e.pageX);
    }
    function handleResize(e) {
    }
    function handleResizeEnd() {
        setInitial(0);
        console.log('end')
    }
    function handleExitSpace() {
    }
    function handleEnterSpace(e) {
        setInSpace(true)
        setInitial(e.pageX)
    }
    useEffect(()=>{
        if(rightSidebarWidth < 300) {
            setRightSidebarWidth(300);
            setInSpace(false);
            setMouseDown(false)
        }
        if (rightSidebarWidth > 1000) {
            setRightSidebarWidth(1000)
            setInSpace(false)
            setMouseDown(false)
        }
    }, [rightSidebarWidth] )

    
    const [sideBarWidth, setSidebarWidth] = useState(300)
    const [oldClientX, setOldClientX] = useState(0)
    const [resizeMode, setResizeMode] = useState('false')

    function resizeRight(e) {
      const clientX = e.clientX
      const diff = clientX - oldClientX
      if(((sideBarWidth - diff) > 250) && ((sideBarWidth - diff) < 1280)) {
      setSidebarWidth(sideBarWidth - diff)
      setOldClientX(clientX)
      }
    }


    return (
        <>
        <span style={{
            position: 'fixed',
            top: 17, 
            right: 125,
            zIndex: 3001,

        }}
        onClick={()=>{
        }}>
            
            <md-icon-button onClick={()=>{
            setRightSideBar(!rightSideBar)}}>
<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="var(--md-sys-color-primary)"><path d="M666-440 440-666l226-226 226 226-226 226Zm-546-80v-320h320v320H120Zm400 400v-320h320v320H520Zm-400 0v-320h320v320H120Zm80-480h160v-160H200v160Zm467 48 113-113-113-113-113 113 113 113Zm-67 352h160v-160H600v160Zm-400 0h160v-160H200v160Zm160-400Zm194-65ZM360-360Zm240 0Z"/></svg></md-icon-button></span>
        <div
            className={rightSideBar
              ? (resizeMode === 'true' ? 'right-sidebar-placeholder cancel-transition': 'right-sidebar-placeholder')
              : 'right-sidebar-placeholder close-sidebar-placeholder'
            }
            style={{ maxWidth: sideBarWidth, minWidth: sideBarWidth } }
          ></div>



{rightSideBar &&
      <div className={rightSideBar ? (resizeMode === 'true' ? 'right-resize show-resize': 'right-resize'): 'right-resize right-resize-close'}
      style={{
        right: sideBarWidth
      }}
      onMouseDown={(e)=>{
        setResizeMode('true');
        setOldClientX(e.clientX);
      }}
      
      ></div>
      }


{resizeMode === 'true' && <div className='resizeme' onMouseMove={resizeRight} onMouseUp={()=>{setResizeMode('false')}}></div>}




        <div className={rightSideBar ? 'right-sidebar': 'right-sidebar right-sidebar-close'} 
        style={{
          width: sideBarWidth,
          minWidth: sideBarWidth
        }}>
            {/*
            <div className="resize-cover" style={{display}}></div>
            <div className={`resize ${showResize}`} onMouseDown={handleResizeStart} onMouseMove={handleResize} onMouseUp={handleResizeEnd} onMouseLeave={handleExitSpace} onMouseEnter={handleEnterSpace}></div>
        */}
            <div className="right-sidebar-container">
                <div>
                    
                    {/** rightSidebarContent === 'ai' ? 
                    <md-filled-button>Ai</md-filled-button> :
                    <md-outlined-button onClick={() => { setRightSidebarContent('ai') }}>Ai</md-outlined-button>
                  
                    
                    {rightSidebarContent === 'FileView' ? 
                    <md-filled-button>File view</md-filled-button> :
                    <md-outlined-button onClick={() => { setRightSidebarContent('FileView') }}>File view</md-outlined-button>
                    }  
    */}
                </div>
<FileView display={rightSidebarContent === 'FileView' ? 'flex' : 'none'} />

            </div>
        </div>
        </>
    )
}
